__turbopack_context__.v({
  "helios-section-header": "zemYMG_helios-section-header",
  "helios-section-header--align-center": "zemYMG_helios-section-header--align-center",
  "helios-section-header--layout-split": "zemYMG_helios-section-header--layout-split",
  "helios-section-header--spacing-compact": "zemYMG_helios-section-header--spacing-compact",
  "helios-section-header--spacing-none": "zemYMG_helios-section-header--spacing-none",
  "helios-section-header--spacing-spacious": "zemYMG_helios-section-header--spacing-spacious",
  "helios-section-header__action": "zemYMG_helios-section-header__action",
  "helios-section-header__actions": "zemYMG_helios-section-header__actions",
  "helios-section-header__content": "zemYMG_helios-section-header__content",
  "helios-section-header__description": "zemYMG_helios-section-header__description",
  "helios-section-header__eyebrow": "zemYMG_helios-section-header__eyebrow",
  "helios-section-header__title": "zemYMG_helios-section-header__title",
  "helios-section-header__title--lg": "zemYMG_helios-section-header__title--lg",
  "helios-section-header__title--md": "zemYMG_helios-section-header__title--md",
  "helios-section-header__title--sm": "zemYMG_helios-section-header__title--sm",
});
